module.exports = __webpack_public_path__ + "img/angle-down.d6091ef8.svg";